import { HTMLAttributes } from 'react';
import { ClearIndicatorProps, components, GroupBase } from 'react-select';

function Container<
  Option = unknown,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({ children, ...props }: Omit<ClearIndicatorProps<Option, IsMulti, Group>, 'className'>) {
  return (
    <components.ClearIndicator {...props} className="d-flex justify-content-center align-items-center me-1 pe-auto">
      {children}
    </components.ClearIndicator>
  );
}

type ButtonProps = Pick<HTMLAttributes<HTMLButtonElement>, 'tabIndex'>;
function Button({ tabIndex }: HTMLAttributes<HTMLButtonElement>) {
  return (
    <button className="btn btn-sm text-primary" tabIndex={tabIndex}>
      <i className="icon icon-sm">cancel</i>
    </button>
  );
}
function Default<
  Option = unknown,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: ClearIndicatorProps<Option, IsMulti, Group> & ButtonProps) {
  return (
    <Container {...props}>
      <Button tabIndex={props.tabIndex} />
    </Container>
  );
}
export const ClearIndicator = {
  Container,
  Button,
  Default,
};
